var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0203 0.0857334C13.0712 0.0414814 13.1312 0.0129976 13.2008 0.000278565H15.2995C15.4705 0.000278565 15.61 0.0604277 15.7174 0.180729L16.9237 1.38703C17.0377 1.50098 17.0945 1.63399 17.0945 1.78597V16.4491C17.0945 16.6011 17.0407 16.7308 16.9329 16.8385C16.8316 16.9459 16.7082 17 16.5627 17L0.541477 16.9997C0.395605 16.9997 0.26908 16.9459 0.161637 16.8382C0.0537896 16.7306 0 16.6007 0 16.449V0.550876C0 0.398909 0.0537896 0.269202 0.161637 0.161504C0.269087 0.0540541 0.399058 0 0.550635 0H3.54211C3.64983 0 3.73541 0.0316649 3.79874 0.0949958C3.843 0.133021 3.87453 0.189992 3.89374 0.265909H3.90328L3.90315 6.10648C3.90937 6.25222 3.96316 6.37557 4.06465 6.47692C4.15965 6.57815 4.28008 6.63194 4.42557 6.63843H12.3839C12.5297 6.63843 12.6563 6.58464 12.7638 6.47692C12.8712 6.3757 12.9285 6.25209 12.9347 6.10648V0.265909C12.9538 0.196483 12.9824 0.136202 13.0201 0.0855905L13.0203 0.0857334ZM11.6055 0.874041V5.8409H9.22158V0.874041H11.6055ZM14.7961 16.0975V9.37407C14.7898 9.22833 14.7361 9.10817 14.6346 9.01316C14.5333 8.91193 14.4097 8.85496 14.2644 8.84238H2.84916L2.78252 8.86132L2.74476 8.86145C2.62459 8.8804 2.5231 8.94068 2.44083 9.0419C2.35219 9.14313 2.30768 9.25389 2.30768 9.37432H2.2984V16.0978L14.7961 16.0975Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/Save.6e655b494757f4f59825c35fdaa455b7.svg";
export { ForwardRef as ReactComponent };